import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { InsuranceComponentWrapper } from '@app/pages/quote/insurance/insurance/insurance-wrapper.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-insurance-mobile',
  templateUrl: './insurance-mobile.component.html',
  styleUrls: ['./insurance-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InsuranceMobileComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InsuranceMobileComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsuranceMobileComponent extends InsuranceComponentWrapper {
  private readonly document = inject(DOCUMENT);

  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService
  ) {
    super(route, menuService, notification);
  }
  openInsuranceFlexModalMobile(){
    this.openInsuranceFlexModal();
    if(this.modalService.component != null){
      this.document.body.style.overflow = 'hidden';
    }
  }

  closeMobileFlexModal(selectedValue?: any){
    if(this.document){
      this.document.body.style.overflow = 'auto';
    }
    this.closeFlexModal(selectedValue);
  }
}
